// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Andorra from '../_raw/flag/icon_flag_andorra.png';

export default () => <img src={Andorra} alt="Andorra" />;
